import React from 'react';
/////Material UI/////
/////Local Shared Types//////
import {IExternalIDUser, LogInType, LogoSize} from 'app/types/Shared';
/////React Router Dom/////

import {useMatomo} from '@jonkoops/matomo-tracker-react';
import {Box, LinearProgress, Link, Typography, useTheme} from '@mui/material';
//import {LogInType} from 'app/types/Shared';
import smallLogo from 'assets/images/header/elevateLogoSmall.svg';
import {selectUserProfile} from 'app/store/auth/authSlice';
import {selectUserType, setUserType} from 'app/store/users/userSlice';
import {useDispatch, useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import PageLayout from 'components/PageLayout/PageLayout';
import TopNavigation from 'components/TopNavigation/TopNavigation';
import LogIn from 'components/LogIn/LogIn';
import EmailPopup from 'components/LogIn/EmailPopup';
import RegistrationForm from 'components/LogIn/RegistrationForm';
import ResponsePopup from 'components/LogIn/ResponsePopup';
import {selectCaptchaToken} from 'app/store/registration/registrationSlice';
import {
  submitFormStatusMessages,
  useSubmitRegistrationFormMutation,
  useLazyValidateUserQuery,
  validEmailStatusMessages,
} from 'app/store/registration/resgistrationApi';

const LogInPage = () => {
  const dispatch = useDispatch();
  const userType = useSelector(selectUserType);
  const isAuthLoading = useSelector(selectUserProfile).isLoading;
  const captchaToken = useSelector(selectCaptchaToken);
  const theme = useTheme();
  const [validateEmail, {isFetching: validateEmailFetching, isLoading: validateEmailLoading}] =
    useLazyValidateUserQuery();
  const [submitRegistrationForm, {isLoading: submitFormLoading}] = useSubmitRegistrationFormMutation();
  const [emailPopupOpen, setEmailPopupOpen] = React.useState(false);
  const [registrationFormOpen, setRegistrationFormOpen] = React.useState(false);
  const [responseOpen, setResponseOpen] = React.useState(false);
  const [responseMessage, setResponseMessage] = React.useState<{title: string; text: React.ReactElement}>({
    title: '',
    text: <></>,
  });
  const [userEmail, setUserEmail] = React.useState('');

  const apiErrorResponse = () => (
    <Typography variant='h5' fontWeight={400} color='black'>
      Please attempt the form again. If this error persist contact{' '}
      <Link href='mailto:DL.Elevate.Support@takeda.com' underline='hover'>
        DL.Elevate.Support@takeda.com
      </Link>
    </Typography>
  );
  // Matomo Analytics
  const {trackPageView} = useMatomo();
  React.useEffect(() => {
    trackPageView();
  });

  const handleLogin = (type: LogInType) => {
    console.log('Setting type' + type);
    dispatch(setUserType(type));
  };

  if (isAuthLoading) {
    return (
      <Box sx={{pt: 10, width: '100%'}}>
        <LinearProgress color='secondary' />
      </Box>
    );
  }

  const header = <TopNavigation authorized={false} smallLogo={smallLogo} LogoType={LogoSize.Small} banner={false} />;

  const registerUser = async (user: IExternalIDUser) => {
    console.log(user);
    /// Call API to register user ** Mulesoft goes here ** //
    if (captchaToken) {
      try {
        const registrationResponse = await submitRegistrationForm({...user, captcha_token: captchaToken});
        if ('data' in registrationResponse) {
          switch (registrationResponse?.data?.status) {
            //API failed to register user, prompt user to try again or contact admin for assistance
            case submitFormStatusMessages.FAILED:
              setResponseMessage({
                title: 'Registration Failed',
                text: (
                  <Typography variant='h5' fontWeight={400} color='black'>
                    Please attempt form again or contact your organization’s admin for assistance.
                  </Typography>
                ),
              });
              setResponseOpen(true);
              break;
            //API successfully registered user, prompt user to log in
            case submitFormStatusMessages.SUCCESS:
              setResponseMessage({
                title: 'Thank you for registering',
                text: (
                  <Typography variant='h5' fontWeight={400} color='black'>
                    You can now accesss ELEVATE clicking the CRO User button
                  </Typography>
                ),
              });
              setResponseOpen(true);
              break;
            //CAPTCHA failed to verify on the server, prompt user to try again
            case submitFormStatusMessages.INVALID_CAPTCHA:
              setResponseMessage({
                title: 'Invalid Captcha Response',
                text: apiErrorResponse(),
              });
              setResponseOpen(true);
              break;
            //User account already exists, prompt user to log in or contact admin for assistance
            case submitFormStatusMessages.EMAILEXIST:
              setResponseMessage({
                title: 'TakedaID account with email already exists',
                text: (
                  <Typography variant='h5' fontWeight={400} color='black'>
                    Please click CRO User button to log in or contact your organization’s admin for assistance.
                  </Typography>
                ),
              });
              setResponseOpen(true);
              break;
            default:
              setResponseMessage({
                title: 'API Error Occured',
                text: apiErrorResponse(),
              });
              setResponseOpen(true);
              break;
          }
        } else {
          //API response is not valid, prompt user to try again
          setResponseMessage({
            title: 'API Error Occured',
            text: apiErrorResponse(),
          });
          setResponseOpen(true);
        }
      } catch (e) {
        console.log(e);
      }

      setRegistrationFormOpen(false);
    }
    return Promise.resolve();
  };

  const handleVerifyEmail = async (email: string) => {
    setUserEmail(email);
    if (captchaToken) {
      try {
        const apiResponse = await validateEmail({email: email, captcha_token: captchaToken});
        if ('data' in apiResponse) {
          switch (apiResponse?.data?.status) {
            //User is not allowed to register, prompt user to contact admin
            case validEmailStatusMessages.INVALID_EMAIL:
              setResponseMessage({
                title: `We didn't recognize your email`,
                text: (
                  <Typography variant='h5' fontWeight={400} color='black'>
                    Please contact your organization’s admin for assistance.
                  </Typography>
                ),
              });
              setResponseOpen(true);
              break;
            // API response is valid, prompt user to register
            case validEmailStatusMessages.VALID_EMAIL:
              setRegistrationFormOpen(true);
              break;
            // CAPTCHA Failed to verify on the server, prompt user to try again
            case validEmailStatusMessages.INVALID_CAPTCHA:
              setResponseMessage({
                title: 'Invalid Captcha Response',
                text: apiErrorResponse(),
              });
              setResponseOpen(true);
              break;
            case validEmailStatusMessages.ALREADY_REGISTERED:
              setResponseMessage({
                title: 'TakedaID account is already registered with ELEVATE',
                text: (
                  <Typography variant='h5' fontWeight={400} color='black'>
                    Please click CRO User button to log in or contact your organization’s admin for assistance.
                  </Typography>
                ),
              });
              setResponseOpen(true);
              break;
            case validEmailStatusMessages.EMAILEXIST:
              setResponseMessage({
                title: 'TakedaID account with email already exists',
                text: (
                  <Typography variant='h5' fontWeight={400} color='black'>
                    Please click CRO User button to log in or contact your organization’s admin for assistance.
                  </Typography>
                ),
              });
              setResponseOpen(true);
              break;
            default:
              setResponseMessage({
                title: 'API Error Occured',
                text: apiErrorResponse(),
              });
              setResponseOpen(true);
              break;
          }
        } else {
          //API response is not valid, prompt user to try again
          setResponseMessage({
            title: 'API Error Occured',
            text: apiErrorResponse(),
          });
          setResponseOpen(true);
        }
      } catch (error) {
        console.log('Error validating email');
        setResponseMessage({
          title: 'API Error Occured',
          text: apiErrorResponse(),
        });
        setResponseOpen(true);
      }
    }
    setEmailPopupOpen(false);
    return Promise.resolve();
  };

  const handleRegistrationClose = () => {
    setRegistrationFormOpen(false);
  };

  if (!userType && !isAuthLoading) {
    return (
      <PageLayout header={header} footer={<Box bgcolor={theme.palette.grey[400]}></Box>}>
        <Box
          sx={{
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            background: theme.palette.grey[100],
          }}
        >
          <Box maxWidth='1400px' mt={12} width='100%'>
            <LogIn selectLogInCallback={handleLogin} />
            <EmailPopup
              open={emailPopupOpen}
              cancel={() => setEmailPopupOpen(false)}
              confirm={handleVerifyEmail}
              pending={validateEmailFetching || validateEmailLoading}
            />
            <RegistrationForm
              title='Create your Takeda ID'
              open={registrationFormOpen}
              email={userEmail}
              confirm={registerUser}
              cancel={handleRegistrationClose}
              pending={submitFormLoading}
            />
            <ResponsePopup
              title={responseMessage.title}
              message={responseMessage.text}
              open={responseOpen}
              confirm={() => {
                setResponseOpen(false);
                setResponseMessage({title: '', text: <></>});
              }}
            />
          </Box>
        </Box>
      </PageLayout>
    );
  }

  return <Navigate to='/' />;
};

export default LogInPage;
